<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">充值</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="老人" required prop="elderlyName">
                <el-input v-model="addForm.elderlyName" placeholder="选择老人" disabled style="">
                  <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                  <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="充值类型" required prop="rechargeType">
                <el-select v-model="addForm.rechargeType" placeholder="请选择充值类型" style="width:100%">
                  <el-option
                      v-for="item in rechargeType_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="充值金额" required prop="addBalance">
                <el-input v-model="addForm.addBalance" placeholder="输入充值金额" style=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="收款金额" required prop="payBalance">
                <el-input v-model="addForm.payBalance" placeholder="输入收款金额" style=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" class="item">
              <el-form-item label="备注" >
                <el-input v-model="addForm.remarks" type="textarea" :rows="2" placeholder="输入备注" style=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>


        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>
      </div>
    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

  </div>
</template>

<script>

import { timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Elderly from "@/views/Elderly/Comm/ElderlyInsCheckIn";


export default {
  name: 'Add',
  data() {
    return {

      loading: false,

      showModalGetElderly:false,


      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        elderlyCode:'',
        elderlyName:'',

        rechargeType:'',

        addBalance:'',
        payBalance:'',

        remarks:'',

      },

      successInfo:'',

      rechargeType_arr:[
        {value:1,label:"现金"},
        {value:2,label:"支付宝"},
        {value:3,label:"微信"},
        {value:4,label:"刷卡"},
        {value:5,label:"补贴"},
        {value:6,label:"转账"},
      ],


      rules:{
        elderlyName:[
          { required: true, message: '请选择老人', trigger: 'blur' },
          { required: true, message: '请选择老人', trigger: 'change' },
        ],
        rechargeType:[
          { required: true, message: '请选择充值类型', trigger: 'blur' },
        ],
        addBalance:[
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          { required: true, message: '请输入充值金额', trigger: 'change' },
        ],
        payBalance:[
          { required: true, message: '请输入收款金额', trigger: 'blur' },
          { required: true, message: '请输入收款金额', trigger: 'change' },
        ],

      }


    }
  },
  components:{
    Elderly
  },
  methods: {
    init(){

      this.$refs.addForm.resetFields();
      this.addForm.remarks = '';

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.addForm.elderlyCode = row.elderlyCode;
      this.addForm.elderlyName = row.name;
    },
    clearElderly(){
      this.addForm.elderlyCode = '';
      this.addForm.elderlyName = '';
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Recharge/InsAdd",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {

              this.$emit("closeAdd");

              this.successInfo = response.data.data.recharge;
              this.successInfo.elderlyName = this.addForm.elderlyName;

              this.$emit("viewPrint",this.successInfo);

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>
<style lang="scss" scoped>

</style>
